import { Layout } from 'antd';
import * as React from 'react';
import classnames from 'classnames';
import './global-footer.less';


const { Footer } = Layout;

interface IGlobalFooterProps {
    links?: any[]
    copyright?: any
    className?: any
}

const GlobalFooter = ({ links, copyright, className }: IGlobalFooterProps) => (
    <Footer className={classnames(className, 'global-footer')}>
        {links && (
            <div className="global-footer-links">
                {links.map((link, index) => (
                    <a key={index} href={link.href}>{link.title}</a>
                ))}
            </div>
        )}
        {copyright && <div className="global-footer-copyright">{copyright}</div>}
    </Footer>
);

export default GlobalFooter;
